// extracted by mini-css-extract-plugin
export default {"wrapper":"wv-z","addressLine":"xv-z","fullName":"yv-z"};